import {GenericResponse} from "../baseresponse";
import {Tier} from "./tier.model";

export class FeeScheduleResponse extends GenericResponse {
  feeSchedule: Tier[];
}
